


  
  

  var faCallbackNote = {
    prefix: 'fak',
    iconName: 'callback-note',
    icon: [
      385,
      512,
      [],
      'e003',
      
      'M.8 63.9C.8 28.7 29.4 0 64.7 0L224.5 0l0 127.8c0 17.7 14.3 32 32 32l127.8 0 0 287.6c0 35.3-28.7 63.9-63.9 63.9l-255.6 0c-35.3 0-63.9-28.7-63.9-63.9L.8 63.9zm255.6 63.9L256.4 0 384.2 127.8l-127.8 0zM137.2 218.6l-34.8 9.5c-6.9 1.9-11.7 8.2-11.7 15.3c0 97.9 79.4 177.4 177.4 177.4c7.1 0 13.4-4.8 15.3-11.7l9.5-34.8c2.1-7.7-1.8-15.7-9.2-18.8l-38-15.8c-6.5-2.7-13.9-.8-18.3 4.6l-16 19.5c-27.9-13.2-50.4-35.8-63.6-63.6l19.5-16c5.4-4.4 7.3-11.9 4.6-18.3l-15.8-38 0 0c-3-7.4-11.1-11.3-18.8-9.2z'
      
    ]
  };

  

  
  

  var faDentalNote = {
    prefix: 'fak',
    iconName: 'dental-note',
    icon: [
      385,
      512,
      [],
      'e004',
      
      'M.5 63.9C.5 28.7 29.2 0 64.4 0L224.2 0l0 127.8c0 17.7 14.3 32 32 32l127.8 0 0 287.6c0 35.3-28.7 63.9-63.9 63.9l-255.6 0c-35.3 0-63.9-28.7-63.9-63.9L.5 63.9zm255.6 63.9L256.2 0 384 127.8l-127.8 0zM145.3 221.7c-25.4 0-46 20.5-46 46l0 3c0 7.6 1.8 15.1 5.1 21.9l11.3 22.7c2.2 4.3 3.7 8.9 4.5 13.6l17.7 99c1 5.4 5.6 9.3 11 9.5s10.3-3.6 11.5-8.9l13.9-58.4c2-8 9.1-13.7 17.3-13.7s15.3 5.6 17.2 13.6l13.9 58.4c1.3 5.3 6.1 9 11.5 8.9s10.1-4.1 11-9.5l17.7-99c.9-4.7 2.4-9.3 4.5-13.6L279 292.5c3.4-6.8 5.1-14.3 5.1-21.9l0-1c0-26.5-21.5-47.9-47.9-47.9c-11.6 0-22.8 4.2-31.6 11.8l-1.5 1.3 9.4 7.3c3.4 2.6 3.9 7.5 1.3 10.8s-7.5 3.9-10.8 1.3l-11.7-9.1-17.8-13.9 .1 0c-8.1-6.3-18-9.7-28.2-9.7z'
      
    ]
  };

  

  
  

  var faDictationNote = {
    prefix: 'fak',
    iconName: 'dictation-note',
    icon: [
      385,
      512,
      [],
      'e00c',
      
      'M1.3 63.9C1.3 28.7 29.9 0 65.2 0L224.9 0l0 127.8c0 17.7 14.3 32 32 32l127.8 0 0 287.6c0 35.3-28.7 63.9-63.9 63.9l-255.6 0c-35.3 0-63.9-28.7-63.9-63.9l0-383.5zm255.6 63.9L256.9 0 384.7 127.8l-127.8 0zM192.5 381.3c58.2 0 105.3-38.4 105.3-85.8s-47.2-85.8-105.3-85.8s-105.3 38.4-105.3 85.8c0 18.6 7.3 35.8 19.6 49.8c-.8 10.1-4.7 19.1-8.8 25.9c-2.3 3.8-4.6 6.8-6.3 8.9c-.9 1.1-1.6 1.9-2 2.3c-.2 .3-.4 .5-.5 .6l-.1 .1c-1.9 1.9-2.4 4.7-1.4 7.2s3.4 4.1 6.1 4.1c11.8 0 23.7-3.7 33.6-8c9.5-4.1 17.4-9 22.3-12.6c13.1 4.7 27.6 7.4 42.8 7.4z'
      
    ]
  };

  

  
  

  var faMicrophoneAdd = {
    prefix: 'fak',
    iconName: 'microphone-add',
    icon: [
      447,
      512,
      [],
      'e000',
      
      'M233.6 75.8c-2.3 5.1-3.6 10.7-3.6 16.6c0 16.1 9.4 30 23 36.5c0 .6 0 1.1 0 1.7l0 146.7c0 48.6-40 88-89.2 88s-89.2-39.4-89.2-88l0-146.7c0-48.6 40-88 89.2-88c28.2 0 53.4 12.9 69.8 33.1zM22.6 218.7c12.4 0 22.3 9.8 22.3 22l0 36.7c0 64.8 53.2 117.3 118.9 117.3s118.9-52.5 118.9-117.3l0-36.7c0-12.2 9.9-22 22.3-22s22.3 9.8 22.3 22l0 36.7c0 81.7-61.5 149.1-141.3 159.9l0 30.8 44.6 0c12.4 0 22.3 9.8 22.3 22s-9.9 22-22.3 22l-66.9 0L97 512c-12.4 0-22.3-9.8-22.3-22s9.9-22 22.3-22l44.6 0 0-30.8C61.8 426.5 .3 359 .3 277.3l0-36.7c0-12.2 9.9-22 22.3-22zM356.4 14.2c0-7.9-6.4-14.2-14.2-14.2S328 6.4 328 14.2v64H264c-7.9 0-14.2 6.4-14.2 14.2s6.4 14.2 14.2 14.2h64v64c0 7.9 6.4 14.2 14.2 14.2s14.2-6.4 14.2-14.2v-64h64c7.9 0 14.2-6.4 14.2-14.2s-6.4-14.2-14.2-14.2h-64v-64z'
      
    ]
  };

  

  
  

  var faMultipetIcon = {
    prefix: 'fak',
    iconName: 'multipet-icon',
    icon: [
      555,
      512,
      [],
      'e008',
      
      'M122.7 67c12.7 20.1 10.8 44-4.2 53.5s-37.5 .9-50.2-19.2s-10.8-44 4.2-53.5s37.5-.9 50.2 19.2zM72.2 136.9C85.9 151 88.3 170.8 77.7 181s-30.4 7.1-44-7.1S17.5 140 28.1 129.8s30.4-7.1 44 7.1l.1 0zm9.9 107.2c8.6-78.7 51.3-108.7 72.2-113.9s72.7 1.3 117.2 66.8c3.1 4.5 5.2 9.6 6.5 14.9l.2 .8c3.3 13.2-4.7 26.4-17.7 29.7c-5.8 1.5-11.8 2.2-17.8 2.1l-47.4-.1c-8.2 0-16.3 2-23.6 5.9l-41.8 22.3c-5.3 2.8-10.9 5-16.7 6.4c-13.1 3.3-26.3-4.8-29.6-17.9l-.2-.8c-1.3-5.3-1.8-10.8-1.2-16.2zM245.7 139.2c-14.2-4-21.3-22.7-15.8-41.6s21.4-30.9 35.6-26.9s21.3 22.7 15.8 41.6s-21.4 30.9-35.6 26.9zm-68.4-33.3c-17.7-1.3-30.6-21.6-28.8-45.2s17.6-41.8 35.4-40.5s30.6 21.6 28.8 45.2s-17.6 41.8-35.4 40.5zM404.5 269.6c-.8 23.6-15.7 42.2-33.4 41.6s-31.4-20.2-30.6-43.9s15.7-42.2 33.4-41.6s31.4 20.2 30.6 43.9zm-80.6 29.2c3.4 19.3-5.7 36.9-20.2 39.4s-28.9-11.2-32.2-30.4s5.6-37 20.1-39.4s28.9 11.2 32.2 30.4l0 0zm-51.8 93.7c51.1-59.9 103-60.8 123.1-53.3s59 41.8 59 120.5c0 5.4-1.1 10.8-3 15.9l-.3 .8c-4.7 12.7-18.6 19.1-31.2 14.5c-5.6-2.1-10.9-4.8-15.8-8.2L365 456.1c-6.8-4.6-14.6-7.5-22.7-8.4l-46.9-5c-5.9-.6-11.7-2-17.3-4c-12.6-4.6-19-18.6-14.3-31.3l.3-.8c1.9-5.1 4.5-9.9 8-14zm193.3 5.2c-9.4-11.3-4.8-30.6 10.2-43.1s34.9-13.5 44.3-2.2s4.8 30.6-10.2 43.1s-34.9 13.5-44.3 2.2zm-37.6-65.7c-13.8-11-13.1-34.9 1.6-53.3s37.9-24.5 51.7-13.5s13.1 34.9-1.6 53.3s-37.9 24.5-51.7 13.5z'
      
    ]
  };

  

  
  

  var faMultipetNote = {
    prefix: 'fak',
    iconName: 'multipet-note',
    icon: [
      385,
      512,
      [],
      'e005',
      
      'M64.2 0C28.9 0 .3 28.7 .3 63.9l0 383.5c0 35.3 28.7 63.9 63.9 63.9l255.6 0c35.3 0 63.9-28.7 63.9-63.9l0-287.6-127.8 0c-17.7 0-32-14.3-32-32L224 0 64.2 0zM383.7 127.8L255.9 0l0 127.8 127.8 0zM112.5 222.5c6.4 10.1 5.5 22.2-2.1 27s-19 .5-25.4-9.7s-5.5-22.2 2.1-27s19-.5 25.4 9.7zM87 257.8c6.9 7.1 8.2 17.1 2.8 22.3s-15.3 3.6-22.2-3.6s-8.2-17.1-2.8-22.3s15.3-3.6 22.2 3.6l0 0zM92 312c4.4-39.7 25.9-54.9 36.5-57.6s36.7 .7 59.2 33.7c1.5 2.3 2.6 4.8 3.3 7.5l.1 .4c1.7 6.6-2.4 13.4-9 15c-2.9 .7-6 1.1-9 1.1l-23.9-.1c-4.2 0-8.3 1-11.9 3l-21.1 11.3c-2.7 1.4-5.5 2.5-8.4 3.2c-6.6 1.6-13.3-2.4-15-9.1l-.1-.4c-.7-2.7-.9-5.5-.6-8.2zm82.7-53c-7.2-2-10.8-11.5-8-21s10.8-15.6 18-13.6s10.8 11.5 8 21s-10.8 15.6-18 13.6zm-34.6-16.8c-9-.7-15.5-10.9-14.6-22.9s8.9-21.1 17.9-20.5s15.5 10.9 14.6 22.9s-8.9 21.1-17.9 20.5zM238 345.9c-8.9-.3-15.8-10.2-15.4-22.2s7.9-21.3 16.9-21s15.8 10.2 15.4 22.2s-7.9 21.3-16.9 21zm-34 13.6c-7.3 1.2-14.6-5.6-16.3-15.4s2.9-18.7 10.2-19.9s14.6 5.6 16.3 15.4l0 0c1.7 9.7-2.9 18.7-10.2 19.9zm46.2 .5c10.2 3.7 29.8 21.1 29.8 60.9c0 2.7-.6 5.5-1.5 8l-.1 .4c-2.4 6.4-9.4 9.7-15.8 7.3c-2.8-1-5.5-2.4-8-4.1l-19.7-13.4c-3.4-2.3-7.4-3.8-11.5-4.2l-23.7-2.5c-3-.3-5.9-1-8.8-2c-6.4-2.3-9.6-9.4-7.2-15.8l.1-.4c1-2.6 2.3-5 4.1-7.1c25.8-30.3 52-30.7 62.2-26.9zm40.6 7.8c7.6-6.3 17.6-6.8 22.4-1.1s2.4 15.5-5.2 21.8s-17.6 6.8-22.4 1.1s-2.4-15.4 5.2-21.8zm-23.4-38.4c7.4-9.3 19.1-12.4 26.1-6.8s6.6 17.6-.8 26.9s-19.1 12.4-26.1 6.8s-6.6-17.6 .8-26.9z'
      
    ]
  };

  

  
  

  var faPackIcon = {
    prefix: 'fak',
    iconName: 'pack-icon',
    icon: [
      535,
      512,
      [],
      'e009',
      
      'M82.5 71.4c1.1-2.7 4.9-2.6 5.9 .1l6.8 18.7c8.1 1.2 16.6 6.1 23 14.1c11.1 14 11.5 32 1 40.3s-28.1 3.7-39.2-10.3c-3.1-3.9-5.3-8.1-6.8-12.3c-3.5-9.5-3.3-20 .6-29.4l8.7-21.3 0 0zM159.3 130c-13.4 .4-24.7-13.6-25.2-31.5c-.3-10.3 3.1-19.5 8.5-25.6l-6.8-18.7c-1-2.7 1.9-5.2 4.4-3.9L160.6 61c9 4.7 15.9 12.6 19.4 22.2c1.6 4.2 2.6 8.8 2.7 13.7c.5 17.8-10 32.6-23.4 33.1zM82.8 161.6c11.4 9.5 14.8 24 7.6 32.5s-22.2 7.7-33.6-1.7c-4.8-3.9-8.2-8.8-9.9-13.7l-.4-1.2c-1.8-5-2-10.5-.6-15.6l6.9-24c.9-3 5-3.1 6-.2l6 16.4c6 .4 12.4 2.9 18 7.6zM98.6 241c.3-59.4 30-85.3 45.3-90.9s54.6-4.8 93.1 40.4c2.6 3.1 4.6 6.7 6 10.6l.2 .6c3.5 9.6-1.4 20.1-11 23.6c-4.3 1.6-8.7 2.6-13.2 3l-35.6 3.7c-6.2 .7-12.1 2.8-17.3 6.3l-29.6 20c-3.7 2.5-7.8 4.6-12 6.1c-9.6 3.5-20.1-1.4-23.6-11l-.2-.6c-1.4-3.9-2.2-7.9-2.2-12zm114.6-91.5c-11-1.9-17.8-15.2-15.1-29.8c1.3-7.1 4.6-13.3 8.9-17.4l-6-16.4c-1-2.9 2.2-5.4 4.7-3.7l20.7 14c4.4 3 7.8 7.3 9.6 12.3l.4 1.2c1.8 4.9 2.4 10.8 1.3 16.9c-2.6 14.6-13.6 24.8-24.6 22.9l-.1 0zM386.6 46.4c1.9-1 4 .8 3.3 2.8L384.9 63c4.1 4.5 6.6 11.3 6.4 18.9c-.3 13.2-8.5 23.6-18.4 23.4S355.2 94.1 355.5 81c.1-3.7 .8-7.1 1.9-10.2c2.5-7 7.6-12.9 14.2-16.5l15-8 0 0zm16 69.5c-7.8-6.1-7.6-19.4 .5-29.7c4.7-6 10.9-9.6 16.9-10.5l4.9-13.8c.7-2 3.5-2.1 4.3-.1l6.5 15.7c2.9 6.9 3.1 14.7 .6 21.7c-1.1 3.1-2.7 6.2-4.9 9.1c-8.1 10.4-21 13.9-28.9 7.8zM344.2 97.8c2 10.7-2.9 20.6-11 22.1s-16.3-6.1-18.3-16.8c-.9-4.5-.5-8.8 .8-12.5l.3-.9c1.3-3.7 3.8-6.9 7-9.1l15.2-10.4c1.9-1.3 4.3 .6 3.5 2.7L337.5 85c3.2 3 5.7 7.5 6.7 12.8zm-28.4 52.5C344 116.7 373 115.9 384.4 120s33.3 23 33.9 66.9c0 3-.5 6-1.6 8.9l-.2 .4c-2.5 7.1-10.3 10.8-17.4 8.2c-3.2-1.1-6.1-2.6-8.9-4.5l-22-14.6c-3.8-2.5-8.2-4.1-12.8-4.6l-26.3-2.6c-3.3-.3-6.6-1-9.7-2.2c-7.1-2.5-10.8-10.3-8.2-17.4l.2-.4c1-2.9 2.5-5.5 4.4-7.9zm108.3 2c-5.3-6.2-2.9-17 5.4-24.1c4.1-3.5 8.8-5.4 13.3-5.7l4.3-12.1c.8-2.1 3.8-2 4.4 .1l5.2 17.7c1.1 3.8 1 7.8-.3 11.5l-.3 .9c-1.3 3.7-3.7 7.3-7.2 10.2c-8.4 7-19.4 7.7-24.8 1.5l0 0zm-2.9 90.8c2.8-.4 4.7 2.9 2.8 5.2l-12.8 15.3c3 7.6 3 17.4-.7 27c-6.5 16.6-21.9 26-34.4 21s-17.2-22.5-10.7-39.1c1.8-4.6 4.3-8.7 7.3-12c6.5-7.8 15.7-12.9 25.8-14.2l22.8-3.1 0 0zm-12.4 95.8c-7.1-11.4-.5-28.2 14.7-37.5c8.7-5.4 18.4-7.1 26.4-5.4l12.8-15.3c1.9-2.2 5.5-1 5.6 1.9l.9 23c.4 10.1-3 20.1-9.5 27.8c-2.8 3.5-6.3 6.6-10.6 9.2c-15.2 9.3-33.3 7.7-40.3-3.7zm-65.6-50.4c-2.5 14.6-13.4 24.8-24.4 22.8s-17.8-15.4-15.3-30c1-6.1 3.5-11.5 6.9-15.4l.8-1c3.4-4.1 8.1-7 13.2-8.3l24.3-6.1c3-.7 5.1 2.8 3.2 5.1L340.7 269c2.7 5.4 3.7 12.2 2.5 19.4zm-60.8 53.4c51.6-29.4 88.9-16.7 101.3-6.2s31.5 44.9 11.6 100.9c-1.4 3.8-3.5 7.4-6.2 10.5l-.4 .5c-6.5 7.8-18.1 8.8-25.9 2.3c-3.5-2.9-6.6-6.2-9.2-9.9l-21-28.9c-3.7-5-8.5-9.1-14.1-11.8l-32.2-15.6c-4.1-2-7.9-4.4-11.3-7.3c-7.8-6.5-8.8-18.1-2.3-25.9l.4-.5c2.6-3.1 5.7-5.9 9.3-7.9zM419 395.3c-3.9-10.4 4.3-23 18.2-28c6.8-2.5 13.8-2.7 19.5-1L467.9 353c1.9-2.3 5.8-.8 5.6 2.3l-1.7 25c-.3 5.3-2.4 10.4-5.8 14.5l-.8 1c-3.3 4-8.2 7.5-14 9.6c-13.9 5-28.3 .6-32.2-9.8l0-.1zM71.9 347.6c.3-2.1 3-2.8 4.2-1l8.4 11.9c6-.7 12.9 1.2 18.9 5.6c10.5 7.8 14.2 20.4 8.3 28.3s-19.2 7.9-29.7 .2c-2.9-2.2-5.3-4.7-7.1-7.4c-4.3-6.1-6.1-13.6-5.2-20.9l2.1-16.7 0 0zm65.4 26.9c-9.4 2.8-20-5-23.8-17.5c-2.2-7.2-1.5-14.4 1.2-19.7l-8.4-11.9c-1.2-1.7 .3-4 2.4-3.6l16.4 3.7c7.2 1.6 13.6 5.9 17.9 12c1.9 2.6 3.5 5.7 4.5 9.2c3.7 12.5-.9 25-10.3 27.8zM89.2 411.4c9.8 4.5 15 14.2 11.5 21.6s-14.3 9.7-24.1 5.1c-4.1-1.9-7.4-4.7-9.6-7.8l-.5-.8c-2.2-3.2-3.4-7-3.3-10.9l.3-18.3c0-2.3 2.9-3.1 4.2-1.3L75 409.4c4.3-.9 9.4-.3 14.2 1.9zm26.2 53.1c-11-42.1 5-66 14.8-72.9s37.7-13.8 73.6 11c2.5 1.7 4.6 3.9 6.3 6.4l.3 .4c4.3 6.1 2.8 14.5-3.3 18.8c-2.7 1.9-5.6 3.5-8.7 4.6l-24.5 9.4c-4.2 1.6-8 4.3-11 7.7l-17.2 19.8c-2.2 2.5-4.6 4.7-7.3 6.6c-6.1 4.3-14.5 2.8-18.8-3.3l-.3-.4c-1.7-2.5-3.1-5.2-3.8-8.1zM179.2 378c-8.1 .7-15.5-7.4-16.4-18.2c-.4-5.3 .7-10.2 3-14l-7.3-10.5c-1.3-1.8 .5-4.2 2.7-3.5l17.3 6c3.7 1.3 6.9 3.7 9.1 6.9l.5 .8c2.2 3.1 3.7 7.2 4.1 11.7c.9 10.8-4.9 20.1-13 20.9l0 0z'
      
    ]
  };

  

  
  

  var faPackModeNote = {
    prefix: 'fak',
    iconName: 'pack-mode-note',
    icon: [
      385,
      512,
      [],
      'e00b',
      
      'M64.2 0C28.9 0 .3 28.7 .3 63.9l0 383.5c0 35.3 28.7 63.9 63.9 63.9l255.6 0c35.3 0 63.9-28.7 63.9-63.9l0-287.6-127.8 0c-17.7 0-32-14.3-32-32L224 0 64.2 0zM383.7 127.8L255.9 0l0 127.8 127.8 0zM93.9 236.7c.6-1.5 2.7-1.4 3.2 .1l3.7 10.2c4.4 .6 9.1 3.3 12.6 7.7c6.1 7.6 6.3 17.5 .5 22s-15.4 2-21.4-5.6c-1.7-2.1-2.9-4.4-3.7-6.7c-1.9-5.2-1.8-11 .3-16.1l4.8-11.6 0 0zm42 32.1c-7.3 .2-13.5-7.5-13.8-17.2c-.2-5.6 1.7-10.7 4.7-14l-3.7-10.2c-.5-1.5 1-2.9 2.4-2.1l11.1 5.8c4.9 2.6 8.7 6.9 10.6 12.1c.9 2.3 1.4 4.8 1.5 7.5c.3 9.8-5.5 17.9-12.8 18.1zM94.1 286.1c6.2 5.2 8.1 13.2 4.1 17.8s-12.2 4.2-18.4-1c-2.6-2.1-4.5-4.8-5.4-7.5l-.2-.6c-1-2.7-1.1-5.7-.3-8.5l3.8-13.2c.5-1.6 2.7-1.7 3.3-.1l3.3 9c3.3 .2 6.8 1.6 9.9 4.1zm8.7 43.4c.2-32.5 16.4-46.7 24.8-49.7s29.9-2.7 51 22.1c1.4 1.7 2.5 3.7 3.3 5.8l.1 .3c1.9 5.2-.8 11-6 12.9c-2.3 .8-4.7 1.4-7.2 1.7l-19.5 2c-3.4 .4-6.6 1.5-9.5 3.4l-16.2 11c-2 1.4-4.3 2.5-6.6 3.4c-5.2 1.9-11-.8-12.9-6l-.1-.3c-.8-2.1-1.2-4.3-1.2-6.6zm62.7-50.1c-6-1-9.7-8.3-8.3-16.3c.7-3.9 2.5-7.3 4.9-9.5l-3.3-9c-.6-1.6 1.2-3 2.6-2l11.4 7.6c2.4 1.6 4.3 4 5.3 6.7l.2 .6c1 2.7 1.3 5.9 .7 9.3c-1.4 8-7.5 13.6-13.5 12.6l0 0zm96.7-54.9l-2.7 7.6c2.2 2.5 3.6 6.2 3.5 10.3c-.2 7.2-4.7 12.9-10.1 12.8s-9.7-6.1-9.5-13.3c0-2 .4-3.9 1.1-5.6c1.4-3.9 4.2-7.1 7.8-9l8.2-4.4 0 0c1-.5 2.2 .5 1.8 1.6zm7.3 20.2c2.6-3.3 6-5.3 9.3-5.8l2.7-7.6c.4-1.1 1.9-1.1 2.4-.1l3.6 8.6c1.6 3.8 1.7 8 .3 11.9c-.6 1.7-1.5 3.4-2.7 5c-4.4 5.7-11.5 7.6-15.8 4.3s-4.2-10.6 .3-16.3zm-38.3 18.5c-4.4 .8-8.9-3.3-10-9.2c-.5-2.5-.3-4.8 .5-6.8l.2-.5c.7-2 2.1-3.8 3.8-5L234 236c1-.7 2.3 .3 1.9 1.5l-2.4 6.6c1.8 1.7 3.1 4.1 3.7 7c1.1 5.9-1.6 11.3-6 12.1zm28 .1c6.2 2.2 18.3 12.6 18.6 36.6c0 1.6-.3 3.3-.9 4.9l-.1 .2c-1.4 3.9-5.6 5.9-9.5 4.5c-1.7-.6-3.4-1.4-4.9-2.5l-12-8c-2.1-1.4-4.5-2.2-7-2.5L229 295.1c-1.8-.2-3.6-.6-5.3-1.2c-3.9-1.4-5.9-5.6-4.5-9.5l.1-.2c.6-1.6 1.3-3 2.4-4.3c15.4-18.4 31.3-18.8 37.5-16.6zm24.7 4.5c2.2-1.9 4.8-2.9 7.3-3.1l2.4-6.6c.4-1.2 2.1-1.1 2.4 .1l2.9 9.7c.6 2.1 .5 4.3-.2 6.3l-.2 .5c-.7 2-2 4-4 5.6c-4.6 3.9-10.6 4.2-13.6 .8l0 0c-2.9-3.4-1.6-9.3 3-13.2zm-4.6 62.9c1.6-.2 2.6 1.6 1.6 2.8l-7 8.4c1.7 4.2 1.7 9.5-.4 14.8c-3.6 9.1-12 14.2-18.8 11.5s-9.4-12.3-5.8-21.4c1-2.5 2.4-4.7 4-6.6c3.6-4.3 8.6-7 14.1-7.8l12.5-1.7 0 0zm-6.8 52.4c-3.9-6.2-.3-15.4 8-20.5c4.8-2.9 10.1-3.9 14.5-3l7-8.4c1-1.2 3-.5 3 1l.5 12.6c.2 5.5-1.6 11-5.2 15.2c-1.5 1.9-3.5 3.6-5.8 5c-8.3 5.1-18.2 4.2-22.1-2zm-35.9-27.6c-1.4 8-7.4 13.6-13.4 12.5s-9.7-8.4-8.4-16.4c.5-3.3 1.9-6.3 3.8-8.5l.4-.5c1.9-2.2 4.4-3.8 7.2-4.5l13.3-3.3c1.6-.4 2.8 1.5 1.7 2.8l-6.1 7.3c1.5 2.9 2 6.7 1.3 10.6zm-33.3 29.2c28.3-16.1 48.6-9.1 55.5-3.4s17.3 24.6 6.3 55.2c-.7 2.1-1.9 4-3.4 5.8l-.2 .3c-3.6 4.3-9.9 4.8-14.2 1.2c-1.9-1.6-3.6-3.4-5-5.4l-11.5-15.8c-2-2.8-4.7-5-7.7-6.5l-17.6-8.6c-2.2-1.1-4.3-2.4-6.2-4c-4.3-3.6-4.8-9.9-1.2-14.2l.2-.3c1.4-1.7 3.1-3.2 5.1-4.3zM278.1 414c-2.1-5.7 2.4-12.6 10-15.3c3.7-1.3 7.5-1.5 10.7-.5l6.1-7.3c1.1-1.3 3.2-.4 3.1 1.2l-.9 13.7c-.2 2.9-1.3 5.7-3.2 7.9l-.4 .5c-1.8 2.2-4.5 4.1-7.7 5.2c-7.6 2.7-15.5 .3-17.6-5.4l0 0zM90.4 387.3l4.6 6.5c3.3-.4 7.1 .6 10.4 3.1c5.7 4.3 7.8 11.2 4.6 15.5s-10.5 4.3-16.2 .1c-1.6-1.2-2.9-2.6-3.9-4.1c-2.3-3.3-3.3-7.4-2.8-11.5l1.2-9.1 0 0c.1-1.1 1.6-1.5 2.3-.6zm20.5 5.7c-1.2-3.9-.8-7.9 .6-10.8l-4.6-6.5c-.7-.9 .2-2.2 1.3-2l9 2c4 .9 7.5 3.2 9.8 6.6c1.1 1.4 1.9 3.1 2.5 5c2 6.9-.5 13.7-5.6 15.2s-11-2.7-13-9.6zm-7 41.6c-1.9 4-7.8 5.3-13.2 2.8c-2.3-1-4.1-2.6-5.3-4.3l-.3-.4c-1.2-1.7-1.9-3.8-1.8-6l.2-10c0-1.2 1.6-1.7 2.3-.7l4 5.7c2.4-.5 5.1-.2 7.8 1.1c5.4 2.5 8.2 7.8 6.3 11.8zM120 412c5.3-3.7 20.7-7.5 40.3 6c1.3 .9 2.5 2.1 3.4 3.5l.1 .2c2.3 3.3 1.5 7.9-1.8 10.3c-1.5 1-3.1 1.9-4.8 2.5l-13.4 5.1c-2.3 .9-4.4 2.3-6 4.2l-9.4 10.8c-1.2 1.4-2.5 2.6-4 3.6c-3.3 2.3-7.9 1.5-10.3-1.8l-.1-.2c-.9-1.3-1.7-2.8-2.1-4.4c-6-23.1 2.8-36.2 8.1-39.9zm17.8-17.4c-.2-2.9 .4-5.6 1.7-7.7l-4-5.7c-.7-1 .3-2.3 1.5-1.9l9.5 3.3c2 .7 3.8 2 5 3.8l.3 .4c1.2 1.7 2 3.9 2.3 6.4c.5 5.9-2.7 11-7.1 11.4l0 0c-4.4 .4-8.5-4.1-9-10z'
      
    ]
  };

  

  
  

  var faRecapNote = {
    prefix: 'fak',
    iconName: 'recap-note',
    icon: [
      385,
      512,
      [],
      'e002',
      
      'M1 63.9C1 28.7 29.7 0 64.9 0L224.7 0l0 127.8c0 17.7 14.3 32 32 32l127.8 0 0 287.6c0 35.3-28.7 63.9-63.9 63.9l-255.6 0C29.7 511.3 1 482.6 1 447.4L1 63.9zm255.6 63.9L256.7 0 384.5 127.8l-127.8 0zM105.9 236.7c-6.2 0-11.8 3.6-14.4 9.1c-2.7 5.5-1.8 12.2 2 16.9l73.2 89.2 0 31.6c0 4 1.9 7.8 5.1 10.2l25.6 19.2c3.9 2.9 9 3.4 13.4 1.2s7.1-6.6 7.1-11.4l0-50.7L291 262.8c3.9-4.8 4.7-11.4 2.1-17s-8.2-9.1-14.4-9.1l-172.7 0z'
      
    ]
  };

  

  
  

  var faSoapIcon = {
    prefix: 'fak',
    iconName: 'soap-icon',
    icon: [
      435,
      512,
      [],
      'e00a',
      
      'M149.3 74.2c-11.2 0-19.6-10.2-28.1-17.3v0c-4.9-4.1-12.4-6.2-22.4-6.2c-6.4 0-11.6 .8-15.7 2.3c-4 1.5-7 3.5-8.9 6.1s-2.9 5.6-3 8.9c-.1 2.7 .3 5.2 1.4 7.4c1.2 2.1 3 4.1 5.6 5.9c2.5 1.7 5.8 3.3 9.7 4.7s8.6 2.7 14 3.8l18.7 4c12.6 2.7 23.4 6.2 32.4 10.6s16.3 9.5 22.1 15.4c5.7 5.9 9.9 12.4 12.6 19.8c2.7 7.3 4.2 15.3 4.2 24c-.1 15-3.8 27.6-11.3 38s-18 18.3-31.9 23.7c-13.7 5.4-30.3 8.1-49.6 8.1c-19.8 0-37.1-2.9-51.9-8.8c-14.7-5.9-26.1-14.9-34.3-27c-4.1-6.2-7.1-13.2-9.2-21.1c-3.6-13.9 8.6-25.8 23-25.8H41c10.4 0 18.1 8.9 23.8 17.6v0c3.1 4.7 7.5 8.3 13.1 10.8c5.7 2.4 12.5 3.7 20.4 3.7c6.6 0 12.1-.8 16.6-2.4s7.8-3.9 10.1-6.8s3.5-6.2 3.6-9.9c-.1-3.5-1.2-6.5-3.5-9.1c-2.2-2.7-5.7-5-10.7-7.1c-5-2.1-11.7-4.1-20.2-6l-22.7-4.9c-20.2-4.4-36.1-11.7-47.8-21.9C12.2 104.3 6.4 90.2 6.5 72.5C6.4 58 10.3 45.4 18.1 34.6C26 23.7 36.8 15.2 50.7 9.1C64.7 3 80.7 0 98.7 0c18.4 0 34.4 3.1 47.8 9.2s23.8 14.8 31.1 26c2.8 4.2 5 8.7 6.8 13.4c5 13.5-7.3 25.6-21.7 25.6H149.3zm277.8 42.7c0 25.3-4.9 46.7-14.8 64.1c-9.9 17.3-23.2 30.5-40 39.4c-16.8 8.9-35.5 13.3-56.2 13.3c-20.8 0-39.6-4.5-56.4-13.4c-16.7-9-30-22.2-39.9-39.6c-9.8-17.4-14.7-38.7-14.7-63.9c0-25.3 4.9-46.7 14.7-64c9.9-17.4 23.2-30.6 39.9-39.4C276.5 4.5 295.3 0 316.1 0c20.6 0 39.4 4.5 56.2 13.4c16.8 8.9 30.1 22 40 39.4c9.9 17.3 14.8 38.7 14.8 64zm-63.7 0c0-13.6-1.8-25.1-5.5-34.4C354.3 73 349 65.9 342 61.1c-7-4.9-15.6-7.3-25.8-7.3s-18.9 2.4-26 7.3c-7 4.8-12.3 11.9-15.9 21.3c-3.6 9.3-5.3 20.8-5.3 34.4s1.8 25.2 5.3 34.6c3.6 9.3 8.9 16.4 15.9 21.3c7.1 4.8 15.7 7.2 26 7.2s18.9-2.4 25.8-7.2c7.1-4.9 12.4-12 15.9-21.3c3.6-9.4 5.5-20.9 5.5-34.6zM72.9 490.9c-3.3 11-13.4 18.5-24.9 18.5H36.4c-17.7 0-30.2-17.3-24.7-34.1L69.9 299.6c3.5-10.6 13.5-17.8 24.7-17.8h47.1c11.2 0 21.1 7.2 24.7 17.8l58.1 175.6c5.6 16.8-7 34.1-24.7 34.1H188.2c-11.4 0-21.5-7.5-24.9-18.5L119.3 345.3c-.2-.5-.6-.9-1.1-.9v0c-.5 0-1 .3-1.1 .9L72.9 490.9zM54.8 442.7c0-12.8 10.3-23.1 23.1-23.1h79.4c12.8 0 23.1 10.3 23.1 23.1v0c0 12.8-10.3 23.1-23.1 23.1H77.9c-12.8 0-23.1-10.4-23.1-23.1v0zm219.5 66.7c-14.3 0-26-11.6-26-26V307.8c0-14.3 11.6-26 26-26h72.5c16.9 0 31.8 3.3 44.5 10s22.6 16 29.6 28.1s10.6 26.2 10.6 42.3c0 16.3-3.6 30.4-10.9 42.3c-7.2 11.9-17.3 21.1-30.4 27.6c-13 6.4-28.2 9.7-45.6 9.7H309.8c-13.3 0-24-10.7-24-24v0c0-13.3 10.7-24 24-24h22.3c7.3 0 13.5-1.3 18.6-3.8c5.2-2.6 9.2-6.3 11.9-11c2.8-4.7 4.2-10.3 4.2-16.8c0-6.5-1.4-12.1-4.2-16.7c-2.7-4.7-6.7-8.2-11.9-10.7c-5.1-2.5-11.3-3.8-18.6-3.8v0c-12.1 0-21.8 9.8-21.8 21.8V483.4c0 14.3-11.6 26-26 26h-10z'
      
    ]
  };

  

  
  

  var faSoapNote = {
    prefix: 'fak',
    iconName: 'soap-note',
    icon: [
      385,
      512,
      [],
      'e007',
      
      'M.3 63.9C.3 28.7 28.9 0 64.2 0L224 0l0 127.8c0 17.7 14.3 32 32 32l127.8 0 0 287.6c0 35.3-28.7 63.9-63.9 63.9l-255.6 0c-35.3 0-63.9-28.7-63.9-63.9L.3 63.9zm255.6 63.9L255.9 0 383.7 127.8l-127.8 0zM148.1 234.5c3.3 3 6.8 6.2 11.1 6.2l6.5 0c7 0 12.9-5.9 10.5-12.4c-.8-2.3-1.9-4.5-3.3-6.5c-3.5-5.4-8.5-9.6-15.1-12.6s-14.2-4.5-23.1-4.5c-8.7 0-16.5 1.5-23.3 4.4c-6.7 2.9-12 7-15.8 12.3c-3.8 5.2-5.6 11.4-5.6 18.3c0 8.6 2.8 15.4 8.4 20.4c5.6 5 13.4 8.5 23.1 10.6l11 2.4c4.1 .9 7.4 1.9 9.8 2.9c2.4 1 4.1 2.2 5.2 3.4c1.1 1.3 1.6 2.7 1.7 4.4c0 1.8-.6 3.4-1.7 4.8s-2.8 2.5-4.9 3.3s-4.8 1.2-8 1.2c-3.8 0-7.1-.6-9.9-1.8c-2.7-1.2-4.9-2.9-6.4-5.2c-2.8-4.2-6.5-8.5-11.5-8.5l-6.9 0c-7 0-12.9 5.8-11.1 12.5c1 3.8 2.5 7.2 4.4 10.2c4 5.9 9.5 10.2 16.6 13.1c7.2 2.8 15.5 4.3 25.1 4.3c9.4 0 17.4-1.3 24-3.9c6.7-2.6 11.8-6.4 15.4-11.5s5.4-11.2 5.4-18.4c0-4.2-.7-8.1-2-11.6c-1.3-3.6-3.3-6.7-6.1-9.6c-2.8-2.9-6.3-5.4-10.7-7.5s-9.6-3.8-15.7-5.1l-9.1-1.9c-2.6-.5-4.9-1.1-6.8-1.8s-3.5-1.4-4.7-2.3c-1.2-.9-2.1-1.8-2.7-2.9c-.5-1.1-.8-2.3-.7-3.6c0-1.6 .5-3 1.5-4.3s2.4-2.2 4.3-3c2-.8 4.5-1.1 7.6-1.1c4.9 0 8.5 1 10.8 3c.8 .7 1.7 1.5 2.5 2.2zm138.5 57.9c4.8-8.4 7.2-18.8 7.2-31s-2.4-22.6-7.2-31c-4.8-8.4-11.2-14.8-19.4-19.1c-8.1-4.3-17.2-6.5-27.2-6.5c-10.1 0-19.2 2.2-27.3 6.5c-8.1 4.3-14.5 10.7-19.3 19.1c-4.7 8.4-7.1 18.7-7.1 31c0 12.2 2.4 22.5 7.1 30.9c4.8 8.4 11.2 14.8 19.3 19.2c8.1 4.3 17.2 6.5 27.3 6.5c10 0 19.1-2.2 27.2-6.5c8.1-4.3 14.6-10.7 19.4-19.1zm-26.3-47.7c1.8 4.5 2.6 10.1 2.6 16.7s-.9 12.2-2.6 16.7c-1.7 4.5-4.3 8-7.7 10.3c-3.4 2.3-7.6 3.5-12.5 3.5s-9.2-1.2-12.6-3.5c-3.4-2.4-6-5.8-7.7-10.3c-1.7-4.6-2.6-10.1-2.6-16.7s.9-12.2 2.6-16.7c1.8-4.6 4.3-8 7.7-10.3c3.4-2.4 7.6-3.6 12.6-3.6s9.1 1.2 12.5 3.6c3.4 2.3 6 5.8 7.7 10.3zm-138 197.8l3.7-12.2 36.4 0 3.7 12.2c1.6 5.3 6.5 8.9 12 8.9l5.6 0c8.6 0 14.6-8.4 11.9-16.5l-28.1-85c-1.7-5.1-6.5-8.6-11.9-8.6l-22.8 0c-5.4 0-10.2 3.5-11.9 8.6l-28.1 85c-2.7 8.1 3.4 16.5 11.9 16.5l5.6 0c5.5 0 10.4-3.6 12-8.9zm22.5-70.5l10.9 36-22.9 0 10.9-36c.1-.2 .3-.4 .6-.4s.5 .2 .6 .4zm62.5 66.9c0 6.9 5.6 12.6 12.6 12.6l4.8 0c6.9 0 12.6-5.6 12.6-12.6l0-20.1 16.6 0c8.4 0 15.8-1.6 22.1-4.7c6.3-3.1 11.2-7.6 14.7-13.3c3.5-5.8 5.3-12.6 5.3-20.5c0-7.8-1.7-14.7-5.1-20.5s-8.2-10.4-14.4-13.6s-13.3-4.8-21.5-4.8l-35.1 0c-6.9 0-12.6 5.6-12.6 12.6l0 85zm30-43.4l0-19.8c0-5.8 4.7-10.6 10.6-10.6c3.5 0 6.5 .6 9 1.8c2.5 1.2 4.4 2.9 5.8 5.2c1.4 2.2 2 4.9 2 8.1c0 3.1-.7 5.8-2 8.1c-1.3 2.3-3.3 4.1-5.8 5.3c-2.5 1.2-5.5 1.8-9 1.8l-10.6 0z'
      
    ]
  };

  

  
  

  var faUltrasoundNote = {
    prefix: 'fak',
    iconName: 'ultrasound-note',
    icon: [
      385,
      512,
      [],
      'e001',
      
      'M.3 63.9C.3 28.7 28.9 0 64.2 0L224 0l0 127.8c0 17.7 14.3 32 32 32l127.8 0 0 287.6c0 35.3-28.7 63.9-63.9 63.9l-255.6 0c-35.3 0-63.9-28.7-63.9-63.9L.3 63.9zm255.6 63.9L255.9 0 383.7 127.8l-127.8 0zM150.7 203c-7.7 0-13.9 6.2-13.9 13.9l0 27.8c0 30.8 24.9 55.7 55.7 55.7l0 27.8c0 15.4-12.5 27.8-27.8 27.8l-27.8 0c-30.8 0-55.7 24.9-55.7 55.7c0 7.7 6.2 13.9 13.9 13.9s13.9-6.2 13.9-13.9c0-11.5 9.4-20.9 20.9-20.9c10.7 0 15.7 4.1 25.3 12.3c.7 .6 1.5 1.3 2.3 1.9c5.5 4.6 12.4 10 21.6 14c9.3 4.1 20.4 6.6 34.3 6.6c50 0 90.5-40.5 90.5-90.5l0-34.8c0-30.8-24.9-55.7-55.7-55.7c-20.6 0-38.6 11.2-48.3 27.8l-7.4 0c-15.4 0-27.8-12.5-27.8-27.8l0-27.8c0-7.7-6.2-13.9-13.9-13.9zM265.6 349.2c-7.3 .1-12.4-3.4-17.4-7l-.1-.1c-5-3.5-10-7-17.3-6.9c-3.4 0-7.4 .9-11.1 2c.5-2.9 .7-5.9 .7-9l0-27.8c0-15.4 12.5-27.8 27.8-27.8s27.8 12.5 27.8 27.8l0 34.8c0 4.3-.4 8.4-1.3 12.5c-3.1 .8-6.4 1.4-9.2 1.4z'
      
    ]
  };

  



export {

  faCallbackNote,
  

  faDentalNote,
  

  faDictationNote,
  

  faMicrophoneAdd,
  

  faMultipetIcon,
  

  faMultipetNote,
  

  faPackIcon,
  

  faPackModeNote,
  

  faRecapNote,
  

  faSoapIcon,
  

  faSoapNote,
  

  faUltrasoundNote,
  

};
